import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { ProductCardType } from '../../enum/Enum.ts';

export const filterProductByProductType = (data, type) => {
  switch (type) {
    case 'PREPAID':
      return data.filter((product) => product.cardType === 'PREPAID');
    case 'CREDIT':
      return data.filter((product) => product.cardType === 'CREDIT');
    default:
      return [];
  }
};

export const renderIdType = (idType) => {
  switch (idType) {
    case 'cmnd':
      return 'CMND';
    case 'cccd':
      return 'CCCD';
    default:
      return '';
  }
};

export const renderProductType = (productType) => {
  switch (productType) {
    case ProductCardType.PREPAID:
      return ProductCardType.PREPAID;
    case ProductCardType.CREDIT:
      return ProductCardType.CREDIT;
    default:
      return '';
  }
};

export const productsCanBeOpened = (products, type, exceptions) => {
  switch (type) {
    case ProductCardType.PREPAID:
      return products.filter(
        (product) =>
          product.cardType === ProductCardType.PREPAID && !exceptions.includes(product.productCode),
      );
    case ProductCardType.CREDIT:
      return products.filter(
        (product) =>
          product.cardType === ProductCardType.CREDIT && !exceptions.includes(product.productCode),
      );
    default:
      return [];
  }
};

export const customerHasCreditCard = (contracts) => {
  if (contracts.length > 0) {
    for (const ct of contracts) {
      if (ct.product.cardType === ProductCardType.CREDIT) {
        return true;
      }
    }
    return false;
  }
  return false;
};

export const formatDate = (str) => {
  if (str.getDate() < 10 && str.getMonth() < 9) {
    return (
      str.getFullYear() +
      '-' +
      '0' +
      (str.getMonth() + 1) +
      '-' +
      '0' +
      str.getDate()
    );
  }
  if (str.getDate() < 10 && str.getMonth() > 8) {
    return (
      str.getFullYear() + '-' + (str.getMonth() + 1) + '-0' + str.getDate()
    );
  }
  if (str.getDate() > 9 && str.getMonth() < 9) {
    return (
      str.getFullYear() + '-0' + (str.getMonth() + 1) + '-' + str.getDate()
    );
  } else {
    return str.getFullYear() + '-' + (str.getMonth() + 1) + '-' + str.getDate();
  }
};

export const formatMoney = (n, currency) => {
  return (
    n.replace(/./g, function (c, i, a) {
      return i > 0 && c !== ',' && (a.length - i) % 3 === 0 ? ' ' + c : c;
    }) + currency
  );
};

export const MoneyFormatCustom = React.forwardRef(function MoneyFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator=" "
      inputMode="numeric"
    />
  );
});

MoneyFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const ContractNumberFormatCustom = React.forwardRef(
  function ContractNumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        format="####  ####  ####  ####"
      />
    );
  },
);

ContractNumberFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export function deleteAccents(str) {
  str = str.replace(/â/g, 'aa');
  str = str.replace(/ê/g, 'ee');
  str = str.replace(/ô/g, 'oo');
  str = str.replace(/Â/g, 'AA');
  str = str.replace(/Ê/g, 'EE');
  str = str.replace(/Ô/g, 'OO');
  str = str.normalize('NFD');
  str = str.replace(/đ/g, 'dd');
  str = str.replace(/Đ/g, 'DD');
  str = str.replace(/\u0300/g, 'f');
  str = str.replace(/\u0301/g, 's');
  str = str.replace(/\u0303/g, 'x');
  str = str.replace(/\u0309/g, 'r');
  str = str.replace(/\u0323/g, 'j');
  str = str.replace(/\u0306/g, 'w');
  return str;
}

export function checkSearchMethod(number) {
  let searchMethod = 'CONTRACT_NUMBER';
  const numb = number.slice(0, 4)

  if (numb !== '4839' && numb !== '9704') {
    searchMethod = 'CBS_NUMBER';
  }
  return searchMethod;
}

export function removeAccents(str) {
  var AccentsMap = [
    "aàảãáạăằẳẵắặâầẩẫấậ",
    "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
    "dđ", "DĐ",
    "eèẻẽéẹêềểễếệ",
    "EÈẺẼÉẸÊỀỂỄẾỆ",
    "iìỉĩíị",
    "IÌỈĨÍỊ",
    "oòỏõóọôồổỗốộơờởỡớợ",
    "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
    "uùủũúụưừửữứự",
    "UÙỦŨÚỤƯỪỬỮỨỰ",
    "yỳỷỹýỵ",
    "YỲỶỸÝỴ"    
  ];
  for (var i=0; i<AccentsMap.length; i++) {
    var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
    var char = AccentsMap[i][0];
    str = str.replace(re, char);
  }
  return str;
}